import React, { useMemo } from "react"
import { Box } from "@chakra-ui/react"
import useProductSwatch from "@hooks/useProductSwatch"

interface Props {
  option: any
}

const Swatch: React.FC<Props> = option => {
  const { normalisedSwatches } = useProductSwatch()

  const swatchColour = useMemo(
    () => normalisedSwatches?.find(swatch => swatch?.handle === option?.label?.toLowerCase().replace(/\s+/g, ""))?.colour,
    [option?.label, normalisedSwatches]
  )

  return (
    <Box
      outline={option?.checked ? `1px solid black` : `none`}
      border={`1px solid white`}
      mr={1}
      backgroundColor={swatchColour}
      w="20px"
      h="20px"
      borderRadius="50%"
    />
  )
}

export default Swatch
